import { render, staticRenderFns } from "./page9.vue?vue&type=template&id=772187b2&scoped=true&"
import script from "./page9.vue?vue&type=script&lang=js&"
export * from "./page9.vue?vue&type=script&lang=js&"
import style0 from "./page9.vue?vue&type=style&index=0&id=772187b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772187b2",
  null
  
)

export default component.exports